import { getAllDeliveryWindows } from '@app/ducks';
import { isDefined } from '@app/utils/is';
import { DeliveryWindow, Product } from '@typings';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ProductThumbnail } from '../ProductThumbnail';

import { ProductOverviewAttribute } from './ProductOverviewAttribute';

interface Props {
  product?: Product.Standard;
  productId?: string;
  variantName: string;
  deliveryWindowId?: DeliveryWindow.Id;
}

export const ProductOverviewCard = ({ children, product, productId, variantName, deliveryWindowId }: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation(['common']);
  const deliveryWindows = useSelector(getAllDeliveryWindows);

  const deliveryWindow =
    isDefined(deliveryWindowId) ? deliveryWindows.find(delwin => delwin.deliveryWindow === deliveryWindowId) : undefined;

  return (
    <div className="flex w-full flex-col gap-4 rounded-regular border border-neutral-90 bg-white p-3">
      <ProductThumbnail product={product} productId={productId} />
      <dl className="flex w-full flex-col gap-4">
        <ProductOverviewAttribute label="Variant" value={variantName} />
        {isDefined(deliveryWindow) && <ProductOverviewAttribute label={t('common:delivery_window_one')} value={deliveryWindow.name} />}
        {children}
      </dl>
    </div>
  );
};
